import { useState, useCallback, useEffect } from 'react'
import {
  BET_TYPES_AUTO_GENERATE_BET_NUMBER,
  FunctionMenuEnum,
  THREE_NUMBER_LIST,
  TWO_NUMBER_LIST,
} from './constants'
import { BetTypeEnum } from '@/ui-components/components/BetLotto/BetLotto.types'
import {
  calculateDigits,
  countDoubleNumberSelected,
} from './utils/useSelectBetType.utils'
import { BetType } from './types'

const onChangeBetType = (
  newBetType: BetType,
  selectedBetTypes: BetType[],
): BetType[] => {
  const pSelected = new Set([...selectedBetTypes])

  if (
    THREE_NUMBER_LIST.includes(
      newBetType as (typeof THREE_NUMBER_LIST)[number],
    ) &&
    countDoubleNumberSelected(selectedBetTypes) > 0
  ) {
    TWO_NUMBER_LIST?.forEach((x) => pSelected.delete(x))
  } else if (
    TWO_NUMBER_LIST.includes(newBetType as (typeof TWO_NUMBER_LIST)[number])
  ) {
    THREE_NUMBER_LIST?.forEach((x) => pSelected.delete(x))
  }
  if (
    newBetType === FunctionMenuEnum.SWAP_THREE &&
    pSelected.has(BetTypeEnum.THREE_TOD)
  ) {
    pSelected.delete(BetTypeEnum.THREE_TOD)
  }
  if (
    newBetType === BetTypeEnum.THREE_TOD &&
    pSelected.has(FunctionMenuEnum.SWAP_THREE)
  ) {
    pSelected.delete(FunctionMenuEnum.SWAP_THREE)
  }

  if (newBetType === BetTypeEnum.RUN_TOP) {
    pSelected.clear()
    if (selectedBetTypes.includes(BetTypeEnum.RUN_BOTTOM)) {
      pSelected.add(BetTypeEnum.RUN_BOTTOM)
    }
  } else if (newBetType === BetTypeEnum.RUN_BOTTOM) {
    pSelected.clear()
    if (selectedBetTypes.includes(BetTypeEnum.RUN_TOP)) {
      pSelected.add(BetTypeEnum.RUN_TOP)
    }
  } else {
    pSelected.delete(BetTypeEnum.RUN_TOP)
    pSelected.delete(BetTypeEnum.RUN_BOTTOM)
  }

  if (pSelected.has(newBetType)) {
    pSelected.delete(newBetType)
  } else {
    pSelected.add(newBetType)
  }
  const arrData: BetType[] = Array.from(pSelected)

  return arrData
}

export const useSelectBetType = (initialSelected: BetType[] = []) => {
  const [selectedBetTypes, setSelectedBetTypes] =
    useState<BetType[]>(initialSelected)
  const [possibleDigits, setPossibleDigits] = useState<number[]>([3])

  const handleSelectBetType = useCallback(
    (betType: BetType) => {
      if (!BET_TYPES_AUTO_GENERATE_BET_NUMBER[betType]) {
        const newSelected = onChangeBetType(betType, selectedBetTypes)
        setSelectedBetTypes(newSelected)
      }
    },
    [selectedBetTypes],
  )

  // Digits that we need, it calculate based on selected bet types
  useEffect(() => {
    const digits = calculateDigits(new Set(selectedBetTypes), possibleDigits)
    if (JSON.stringify(digits) !== JSON.stringify(possibleDigits)) {
      setPossibleDigits(digits)
    }
  }, [selectedBetTypes, possibleDigits])

  return {
    selectedBetTypes,
    handleSelectBetType,
    inputDigit: Math.max(...possibleDigits),
  }
}
